import { FC, useState } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';

import { Box, H6 } from '@parspec/pixel';

import { GMAIL_CONFIG } from 'src/features/BOM/FinalDocuments/EmailPopup/constants';
import { ISnackbarDataState } from '../types';
import EmailPreferences from './EmailPreferences';
import { Preferences } from './Preferences/Preferences';

const PreferencesTab: FC = () => {
    const [snackbarData, setSnackbarData] = useState<ISnackbarDataState>({
        isActive: false,
        message: ''
    });

    return (
        <Box overflow="auto">
            <H6>Preferences</H6>
            <Preferences snackbarData={snackbarData} setSnackbarData={setSnackbarData} />
            <GoogleOAuthProvider clientId={GMAIL_CONFIG.clientId}>
                <EmailPreferences snackbarData={snackbarData} setSnackbarData={setSnackbarData} />
            </GoogleOAuthProvider>
        </Box>
    );
};

export default PreferencesTab;
